import React, { FC } from 'react';

import { Checkbox, Text } from '@chakra-ui/react';

interface Props {
  value: string;
  label: string;
  selectedValue: string;
  onChange: (value: string) => void;
}

// Keep the filter control independent so IdentityPermissions stays focused on
// coordinating permission data instead of rendering individual form fields.
export const PermissionUsageCheckbox: FC<Props> = ({
  value,
  label,
  selectedValue,
  onChange,
}) => (
  <Checkbox
    isChecked={selectedValue === value}
    onChange={event => onChange(event.target.checked ? value : '')}
  >
    <Text>{label}</Text>
  </Checkbox>
);
